<template>
	<div>
		<v-layout justify-center>
			<v-flex xs12 sm12 md12 lg12>
				<v-container>
					<v-row no-gutters>
						<v-col xs="12" sm="12" md="12" class="mt-4">
							<carousel :images="images" />
							<p style="text-align:center" class="pa-4">{{ about }}</p>
							<staff type="Camp" />
							<v-card flat tile class="pa-4" outlined>
								<v-card-title style="text-align: center"
									>{{ title }} Information</v-card-title
								>
								<ul v-for="(c, index) in prices" :key="index">
									<div>
										<ul v-for="(c, index) in prices" :key="index">
											<div><b>Price:</b> {{ c.price }}</div>
											<div><b>Ages:</b> {{ c.ages }}</div>
											<div><b>Time: </b>{{ c.time }}</div>
											<div><b>Days: </b>{{ c.days }}</div>
										</ul>
									</div>
								</ul>
							</v-card>
						</v-col>
					</v-row>
					<upcoming />
				</v-container>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
//import fb from '@/fb'
import carousel from "../../components/carosel.vue";
import { Events } from "../../Models/Events";
import _ from "lodash";
import upcoming from "../../components/kidsCampShow.vue";
import staff from "../../components/staff";
import Staff from "../../components/staff.vue";

export default {
	components: {
		carousel,
		upcoming,
		staff,
		Staff,
	},
	data() {
		return {
			title: "",
			id: "",
			about: "",
			images: [],
			prices: [],
		};
	},
	methods: {},
	created() {
		const kidsCamp = _.find(Events, (evt) => {
			return evt.id === "kids-camps";
		});
		_.assign(
			this,
			_.pick(kidsCamp, ["images", "about", "prices", "title", "id"])
		);
	},
};
</script>
